import { TemplatePage } from './types';

const trendingHashtagsPage: TemplatePage = {
  header: {
    color: '#FFD35C',
    icon: 'images/video-templates/trending_hashtags.jpg',
    title: 'Trending hashtags video templates',
    title_meta: '100+ Free Trending Hashtags Video Templates',
    description_meta:
      'Step up your social media content game with Wave.video’s collection of 100+ Trending Hashtags video templates.',
    description:
      'Step up your social media content game with the collection of 100+ Trending Hashtags video templates. Boost ' +
      'your social presence with the power of video.'
  },
  footer: {
    category: 'Trending hashtags',
    description:
      'With Wave.video’s impressive collection of trending hashtags video templates, you can easily create unskippable ' +
      'videos for your social media, blog, website, or email newsletter in a matter of minutes. All the templates ' +
      'are free and easy to customize to reflect your brand and resonate with your customers.'
  },
  content: [
    {
      type: 'templates',
      title: 'Trending hashtags videos',
      search: { category: '/Use Cases/Trending-Hashtags' }
    },
    {
      type: 'stocks',
      title: 'hashtags',
      search: { name: 'hashtags' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default trendingHashtagsPage;
